/* Built by Ryan in the "[DEV] Ryan - Omnilux LED Advertorial v3 LP" theme, merged 2026-10-05. Not built by our team; see docs/ryan-led-rlt-templates.md. */
/* RLT guide — responsive rail.
 *
 * On desktop the product + review cards live in the sticky rail (a separate grid
 * column). On mobile that column can only sit above or below the whole article,
 * never between its sections — so here we physically move each card into a slot
 * inside the article (<div data-rlt-mobile-slot="…">) below the breakpoint, and
 * move it back into the rail above it. Progressive enhancement: with JS off, the
 * rail just falls back to sitting at the top of the page.
 */
(function () {
  var BREAKPOINT = '(max-width: 989px)'; // keep in sync with rlt-guide.css
  var rail = document.querySelector('.rlt-rail');
  var railCol = document.querySelector('.rlt-rail-col');
  var article = document.querySelector('.rlt-main');
  if (!rail || !article) return;

  // Remember each card's original position in the rail so desktop can be restored
  // exactly, regardless of how many cards or what order they're in.
  var cards = Array.prototype.slice.call(rail.children).filter(function (el) {
    return el.classList && el.classList.contains('rlt-card');
  });
  cards.forEach(function (card, i) { card.__railIndex = i; });

  // Map each card to a named slot. A review card carries .rlt-review; anything
  // else in the rail is treated as the product card.
  function slotNameFor(card) {
    return card.classList.contains('rlt-review') ? 'review' : 'product';
  }

  function toMobile() {
    cards.forEach(function (card) {
      var slot = article.querySelector('[data-rlt-mobile-slot="' + slotNameFor(card) + '"]');
      if (slot && card.parentNode !== slot) slot.appendChild(card);
    });
    // CSS already hides the empty rail on mobile (.rlt-js). Only override that if a
    // card was left behind (no matching slot) — it must stay visible, not vanish.
    if (railCol) railCol.style.display = rail.querySelector('.rlt-card') ? 'block' : '';
  }

  function toDesktop() {
    cards
      .slice()
      .sort(function (a, b) { return a.__railIndex - b.__railIndex; })
      .forEach(function (card) {
        if (card.parentNode !== rail) rail.appendChild(card);
      });
    // Clear any inline override so the CSS (rail visible on desktop) takes over.
    if (railCol) railCol.style.display = '';
  }

  var mq = window.matchMedia(BREAKPOINT);
  function apply() { mq.matches ? toMobile() : toDesktop(); }

  apply();
  if (mq.addEventListener) {
    mq.addEventListener('change', apply);
  } else if (mq.addListener) {
    mq.addListener(apply); // Safari < 14
  }
})();
